<template>
  <el-select ref="virtualSelect" v-model="selected" v-bind="$attrs" v-on="$listeners" @clear="resetChecked" @focus="selectFocus" class="virtual-select">
    <el-option v-for="item in []" :key="item.value" :label="item.label" :value="item.value"></el-option>
    <div slot="empty" class="virtual-select__box">
      <!-- <el-input placeholder="输入关键字进行过滤" v-model="filterText" class="virtual-select__search" clearable @input="inputChange">
        <el-button slot="prepend"></el-button>
      </el-input> -->
      <diyInput v-model="filterText" clearable @input="inputChange" placeholder="输入关键字进行过滤"></diyInput>
      <virtual-tree
        ref="virtualTree"
        :data="originData"
        :props="props"
        :multiple="isMultiple"
        :expandLevel="expandLevel"
        :checked="checkedValues"
        :showDelete="isShowDelete"
        v-bind="$attrs"
        @change="checkedChange" ></virtual-tree>
    </div>
  </el-select>
</template>

<script>
import virtualTree from './src/virtualTree'
import diyInput from './src/diyInput'
import XEUtils from 'xe-utils'
export default {
  name: 'customVirtualTree',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    checked: { // 选中值
      type: Array | Number | String,
      default: () => []
    },
    props: {
      type: Object,
      default () {
        // isTree 表示数据源是否是树形结构
        return {label: 'label', id: 'value', parentId: 'ParentId', isTree: true, children: 'children', status: 'Status', statusValue: '-1'}
      }
    },
    multiple: { // 是否多选
      type: Boolean,
      default: () => true
    },
    showDelete: { // 是否显示删除项
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      selected: '',
      filterText: '',
      originData: [],
      checkedValues: [],
      checkedItems: [],
      isManualChange: false, // 是否选择（区分初始化）
      expandLevel: 2
    }
  },
  created () {
    this.initOriginData()
  },

  computed: {
    isMultiple () {
      return this.multiple || this.$attrs.showCheckbox || false
    },
    isShowDelete () {
      return this.showDelete || this.$attrs.filterDelete || false
    },
    checkedArray () {
      return Array.isArray(this.checked) ? this.checked : ((this.checked && `${this.checked}`.split(',')) || [])
    }
  },
  components: {
    virtualTree, diyInput
  },
  methods: {
    initOriginData (values) {
      this.originData = (this.data || [])
      const {id} = this.props
      const {status, statusValue} = this.getPropStatus()
      const checked = this.checkedArray
      this.originData = (this.data || []).filter(item => !statusValue.includes(`${item[status]}`)).map(item => ({
        ...item,
        checked: (values || [...checked]).includes(`${item[id]}`) || (values || [...checked]).includes(+item[id])
      }))
      if (this.filterText) {
        this.originData = (this.data || []).filter(item => this.getFieldsLabel(item).includes(this.filterText)).map(item => ({
          ...item,
          checked: (values || [...checked]).includes(`${item[id]}`) || (values || [...checked]).includes(+item[id])
        }))
        if (!this.isShowDelete) {
          this.originData = this.originData.filter(item => !statusValue.includes(`${item[status]}`))
        }
      }
      this.initChecked()
    },
    initChecked () {
      const { id, cancelField, cancelValue } = this.props
      const { status, statusValue } = this.getPropStatus()
      const checked = this.checkedArray
      // console.log('🚀 ~ file: index.vue:86 ~ initChecked ~ checked:', checked)
      this.checkedValues = [...checked]
      if (this.isMultiple) {
        let items = (this.data || []).filter(item => checked.includes(`${item[id]}`) || checked.includes(+item[id]))
        if (!this.isShowDelete) {
          items = items.filter(item => !statusValue.includes(`${item[status]}`))
          if (cancelField) {
            items = items.filter(item => `${item[cancelField]}` !== `${cancelValue}`)
          }
        }
        this.selected = items.length > 0 ? `${items.length}项已选择` : ''
      } else {
        const _checked = (checked && checked.length > 0 && checked[0]) || ''

        const item = (this.data || []).find(item => `${item[id]}` === `${_checked}`)
        this.selected = this.getFieldsLabel(item)
      }
    },
    resetChecked () {
      this.filterText = ''
      const {status, statusValue} = this.getPropStatus()
      this.originData = (this.data || []).filter(item => !statusValue.includes(`${item[status]}`)).map(item => ({
        ...item,
        checked: false
      }))
      this.$refs['virtualTree'].reset()
    },
    selectFocus () {
      this.$emit('select-focus') // 处理select点击提示
      this.$refs['virtualTree'].refreshTree()
    },
    getParentKeys (items, originItems, parentValue) {
      const { id, parentId = 'ParentId' } = this.props
      const parentKeys = items.map(item => item[parentId])
      const parentItems = originItems.filter(item => parentKeys.includes(item[id]))
      if (!parentKeys.includes(parentValue) && items.length > 0) {
        return [...parentKeys, ...this.getParentKeys(parentItems, originItems, parentValue)]
      }
      return parentKeys
    },
    inputChange (val) {
      // console.log('🚀 ~ file: index.vue:107 ~ inputChange ~ val:', val, this.isShowDelete, this.$attrs)
      this.expandLevel = val ? 20 : 2
      this.initOriginData(this.checkedValues)
      const { id } = this.props
      const {status, statusValue} = this.getPropStatus()

      const _this = this
      const func = XEUtils.debounce(function (val) {
        if (val) {
          let _data = []
          if (_this.isShowDelete) {
            _data = _this.data.filter(item => _this.getFieldsLabel(item).includes(val))
          } else {
            /** 这种方式不支持在 软件内的搜索 */
            // _this.originData = _this.originData.filter(item => _this.getFieldsLabel(item).includes(val))
            _data = _this.data.filter(item => !statusValue.includes(`${item[status]}`) && _this.getFieldsLabel(item).includes(val))
          }
          /** 筛选显示关联父级节点显示 BEGIN */
          const keys = _data.map(item => item[id])
          const tempKeys = _this.getParentKeys(_data, _this.data, '0')
          _data = _this.data.filter(item => [...tempKeys, ...keys].includes(item[id]))
          /** 筛选显示关联父级节点显示 END */

          _this.originData = _data.map(item => ({
            ...item,
            checked: _this.checkedValues.includes(`${item[id]}`)
          }))
          // console.log('🚀 ~ file: index.vue:132 ~ func ~ _this.originData:', _this.originData, id, _this.checkedValues)
        }
      }, 100)
      func(val)
    },
    getFieldsLabel (item) {
      const { label } = this.props
      return (item && label.split(',').map(fieldLabel => {
        if (fieldLabel.includes('|')) {
          let result = ''
          const arr = fieldLabel.split('|')
          for (let i = 0; i < arr.length; i++) {
            result = item[arr[i]]
            if (result) {
              break
            }
          }
          return result
        }
        return item[fieldLabel]
      }).join('-')) || ''
    },
    checkedChange (values, items, row) {
      // console.log('🚀 ~ file: index.vue:155 ~ checkedChange ~ row:', row, values)
      this.selected = ''
      this.isManualChange = true
      const { id } = this.props
      if (this.isMultiple) {
        if (!row) {
          this.checkedValues = []
          this.checkedItems = []
          this.$emit('change', [], [])
          return
        }
        let _values = []
        let _items = []
        if (this.filterText && row.multiple) { // 处理 筛选的场景下，获取子集数据
          const { items: childItems } = this.getItemChild(row)
          const { getFieldsLabel, filterText } = this
          const tempItems = childItems.filter(item => getFieldsLabel(item).includes(filterText))
          _values = tempItems.map(item => item[id]) // childValues
          _items = tempItems // childItems
        }
        if (row.checked) {
          if (this.filterText && row.multiple) { // 处理 筛选的场景下，获取子集数据
            values = [...values, ..._values]
            items = [...items, ..._items]
          }
          this.checkedValues = [...this.checkedValues, ...values]
          this.checkedItems = [...this.checkedItems, ...items]
        } else {
          this.checkedValues = [...new Set(this.checkedValues)]
          if (row.multiple) { // 包含子集
            XEUtils.toTreeArray([row], {clear: false}).forEach(item => {
              const index = this.checkedValues.findIndex(value => `${value}` === `${item[id]}`)
              index !== -1 && this.checkedValues.splice(index, 1)
              index !== -1 && this.checkedItems.splice(index, 1)
            })
            if (this.filterText) {
              _values.forEach(item => {
                const index = this.checkedValues.findIndex(value => `${value}` === `${item}`)
                index !== -1 && this.checkedValues.splice(index, 1)
                index !== -1 && this.checkedItems.splice(index, 1)
              })
            }
          } else {
            const index = this.checkedValues.findIndex(item => `${item}` === `${row[id]}`)
            // console.log('🚀 ~ file: index.vue:158 ~ checkedChange ~ index:', index, id)
            index !== -1 && this.checkedValues.splice(index, 1)
          }
        }
        if (this.checkedValues && this.checkedValues.length) {
          this.selected = `${this.checkedValues.length}项已选择`
        }
      } else {
        this.selected = this.getFieldsLabel(items)
        this.checkedValues = [values]
        this.$refs['virtualSelect'].blur()
        this.$emit('change', values, items)
        return
      }
      // this.$emit('update:checked', values)
      this.checkedValues = [...new Set(this.checkedValues)]
      this.checkedItems = this.data.filter(item => this.checkedValues.includes(`${item[id]}`) || this.checkedValues.includes(+item[id]))
      const { originData, checkedValues } = this
      if (row.multiple && row.children && row.children.length > 0 && this.filterText) {
        if (checkedValues.length > originData.length && row.checked) {
          this.originData = originData.map(item => ({
            ...item,
            checked: checkedValues.includes(`${item[id]}`) && !item.disabled && !item.readonly
          }))
        } else if (!row.checked) {
          this.originData = this.originData.map(item => ({
            ...item,
            checked: row.checked ? row.checked && !item.disabled && !item.readonly : (row.checked || checkedValues.includes(`${item[id]}`))
          }))
        }
      }
      // this.$emit('change', values, items)
      this.$emit('change', this.checkedValues, this.checkedItems)
    },
    getItemChild (row) {
      const { id, parentId } = this.props
      const {status, statusValue} = this.getPropStatus()
      const tree = XEUtils.toArrayTree(this.data, {'parentKey': parentId || 'ParentId', 'key': id, 'strict': false})
      // const _items = XEUtils.toTreeArray([row], {clear: false}).filter(item => item[id] === row[id])
      const _items = XEUtils.toTreeArray(tree, {clear: false}).filter(item => item[id] === row[id])
      // console.log('🚀 ~ file: index.vue:223 ~ getItemChild ~ _items:', _items)
      let childItems = XEUtils.toTreeArray(_items, {clear: false})
        .filter(item => item[id] !== row[id]) // 过滤掉当前行
        // .filter(item => !statusValue.includes(`${item[status]}`)) // 过滤掉无效状态（删除的数据）
      if (!this.filterText) {
        childItems = childItems.filter(item => !statusValue.includes(`${item[status]}`)) // 过滤掉无效状态（删除的数据）
      }

      /* const { id } = this.props
      const childItems = row.children */
      const childValues = childItems.map(item => item[id])
      // console.log('🚀 ~ file: index.vue:171 ~ checkedChange ~ _values:', childItems)
      return {
        values: childValues,
        items: childItems
      }
    },
    getPropStatus () {
      const { status, statusValue } = this.props
      const _status = status || 'Status'
      const _statusValues = (statusValue || '-1').split(',')
      return {
        status: _status,
        statusValue: _statusValues
      }
    },
    // 将originData的checked置为false
    clearOriginData () {
      this.originData = this.originData.map(item => ({
        ...item,
        checked: false
      }))
    }
  },
  watch: {
    'data': function () {
      this.initOriginData()
    },
    'checked': function (newVal) {
      this.initChecked()
      if (this.isManualChange && newVal.length === 0) {
        this.clearOriginData()
      }
      !this.isManualChange && this.initOriginData()
    }
  }

}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/virtualTree/index.vue